import type { HelpModuleConfig } from '@/types/help'

export const helpModules: HelpModuleConfig[] = [
  {
    id: 'getting-started',
    title: 'Inicio Rápido',
    icon: 'Rocket',
    order: 0,
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'LayoutDashboard',
    order: 1,
  },
  {
    id: 'organizations',
    title: 'Organizaciones',
    icon: 'Building2',
    roles: ['superadmin', 'tenant_admin', 'admin', 'operator'],
    order: 2,
  },
  {
    id: 'projects',
    title: 'Proyectos',
    icon: 'FolderKanban',
    order: 3,
  },
  {
    id: 'backlog',
    title: 'Backlog y Sprints',
    icon: 'ListTodo',
    roles: ['superadmin', 'tenant_admin', 'admin', 'operator'],
    order: 4,
  },
  {
    id: 'requirements',
    title: 'Requerimientos',
    icon: 'ClipboardList',
    order: 5,
  },
  {
    id: 'epics',
    title: 'Épicas',
    icon: 'Layers',
    order: 6,
  },
  {
    id: 'petitions',
    title: 'Peticiones',
    icon: 'MessageSquarePlus',
    order: 7,
  },
  {
    id: 'tickets',
    title: 'Tickets',
    icon: 'Ticket',
    order: 8,
  },
  {
    id: 'releases',
    title: 'Releases',
    icon: 'PackageCheck',
    roles: ['superadmin', 'tenant_admin', 'admin', 'operator'],
    order: 9,
  },
  {
    id: 'crm',
    title: 'CRM',
    icon: 'Users',
    roles: ['superadmin', 'tenant_admin', 'admin'],
    order: 10,
  },
  {
    id: 'calendar',
    title: 'Calendario',
    icon: 'Calendar',
    order: 11,
  },
  {
    id: 'meetings',
    title: 'Reuniones',
    icon: 'Video',
    order: 12,
  },
  {
    id: 'documents',
    title: 'Documentos',
    icon: 'FileText',
    order: 13,
  },
  {
    id: 'quotations',
    title: 'Cotizaciones',
    icon: 'Receipt',
    roles: ['superadmin', 'tenant_admin', 'admin', 'operator'],
    order: 14,
  },
  {
    id: 'sales-orders',
    title: 'Órdenes de Venta',
    icon: 'ShoppingCart',
    roles: ['superadmin', 'tenant_admin', 'admin'],
    order: 15,
  },
  {
    id: 'profile',
    title: 'Perfil y Preferencias',
    icon: 'UserCog',
    order: 16,
  },
  {
    id: 'admin',
    title: 'Administración',
    icon: 'Settings',
    roles: ['superadmin', 'tenant_admin', 'admin'],
    order: 17,
  },
  {
    id: 'copilot',
    title: 'Copilot IA',
    icon: 'Bot',
    roles: ['superadmin', 'tenant_admin', 'admin', 'operator'],
    order: 18,
  },
  {
    id: 'super-admin',
    title: 'Super Admin',
    icon: 'Shield',
    roles: ['superadmin'],
    order: 19,
  },
]
